import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => {
    return css`
        visibility:${displayState?.show ? 'visible' : 'hidden'};
        display: flex; 
        align-items: center; 
        justify-content: center;
  `}}
`;

export default Wrapper(template)
